<template>
  <section class="section promo-section dark-bg">
    <div class="container">
      <div class="promo">
        <div class="promo__wrapper">
          <div class="promo__content promo-text">
            <h1 class="main-title" data-aos="fade-right" data-aos-duration="800" data-aos-delay="0">
              ERP | MES системы - <br />
              формат поддержки на выбор
            </h1>
            <div>
              <p class="promo__subtitle text text--bold">
                Мы устанавливаем и разворачиваем систему <br />
                TERPO на вашей инфраструктуре.
              </p>
              <p class="promo__subtitle text text--bold">
                Вы сами определяете: поддерживать её своими <br />
                силами или передать поддержку нам.
              </p>
            </div>
            <div class="promo__button-container">
              <nuxt-link :to="{ path: '/support', hash: '#request' }" class="button animated-btn promo__btn">Отправить заявку</nuxt-link>
            </div>
          </div>
          <img src="/img/support/support_promo.png" class="promo__img" />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use '~/assets/styles/mixins';

.promo-section {
  position: relative;
  overflow: hidden;

  &::before {
    @include mixins.pseudo-elem;
    @include mixins.radial-gradient;
    top: -20%;
    right: -10%;
    width: 40%;
    aspect-ratio: 1 / 1;
    z-index: 1;
  }
}

.promo {
  position: relative;
  z-index: 1;
  &__wrapper {
    display: flex;
    justify-content: space-between;
    gap: 50px;
  }

  &__subtitle:first-child {
    margin-bottom: 20px;
  }

  &__content {
    text-align: left;
    align-items: flex-start;
  }

  &__btn {
    padding: 16px 32px;
  }

  &__img {
    object-fit: contain;
    width: 538px;
    max-width: 40%;
  }

  &__button-container {
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
  }
}

@media (max-width: 1024px) {
  .promo__wrapper {
    padding: 70px 0 0;
  }
  .promo {
    padding: 40px 0;

    &__img {
      display: none;
    }
  }

  .promo-section {
    &::before {
      width: 607px;
      height: 607px;
      left: -200px;
      bottom: -80px;
    }
  }
}

@media (max-width: 767px) {
  .promo-section {
    &::before {
      left: -200px;
      top: 10px;
      left: auto;
    }
  }

  .promo {
    &__wrapper {
      flex-direction: column;
      align-items: flex-start;
      gap: 30px;
      padding: 0;
    }

    &__content {
      width: 100%;
      max-width: 100%;
      padding-bottom: 0;
    }
  }
}

@media (max-width: 500px) {
  .promo {
    &__btn-container {
      flex-direction: column;
    }

    &__btn {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
